<template>
  <div>
    <b-modal :title="`Add Post Code to Sku: ${skuCode}`" v-model="isShow">
      <b-row>
        <b-col md="3">รหัสไปรษณีย์</b-col>
        <b-col md="6">
          <b-form-input
            v-model="filter.keyword"
            type="text"
            placeholder="รหัสไปรษณีย์"
            @keydown.enter="onFilter"
            :state="filter.state"
            @keypress="validateNum2($event)"
            @keyup="validatePostCode"
            maxlength="5"
          ></b-form-input>
          <!-- This will only be shown if the preceding input has an invalid state -->
          <b-form-invalid-feedback>
            <i class="fas fa-info-circle"></i>
            {{ filter.invalidFeedbackSMG }}
          </b-form-invalid-feedback>
        </b-col>
        <b-col md="3">
          <b-button variant="success" @click="onFilter">
            <i class="fa fa-plus"></i> Add
          </b-button>
        </b-col>
      </b-row>
      <BkTable
        :fields="fields"
        hideSelectPerPage
        hideSearch
        hideFooter
        small
        :items="items"
      >
        <template v-slot:cell(action)="data">
          <div class="text-center">
            <a
              @click="onDeletePostcode(data)"
              class="btn btn-ico text-danger"
              title="Delete"
            >
              <i class="fas fa-trash-alt"></i>
            </a>
          </div>
        </template>
        <template v-slot:cell(province)="{ value }">
          <span class="badge-lang">TH</span> {{ value.th }}
          <br />
          <span class="badge-lang">EN</span> {{ value.en }}
        </template>
      </BkTable>
      <template #modal-footer="{ ok, cancel, hide }">
        <div class="text-center w-100">
          <b-button
            variant="primary"
            @click="onSaveAddPostCode"
            :disabled="!items || items.length === 0"
          >
            <i class="fas fa-save"></i> Save
          </b-button>
          <b-button
            variant="light"
            @click="onResetAddPostCode"
            :disabled="!items || items.length === 0"
          >
            <i class="fa fa-undo"></i> Reset
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import productDeliveryRestrictionService from '@/helpers/service/product-delivery-restriction-service.js'
import productService from '@/helpers/service/product-service.js'
import { FormatQty } from '@/helpers/utils/format-qty.js'
import BkTable from '@/components/share/bk-table'
import validate from '@/helpers/utils/validate.js'
export default {
  mixins: [validate],
  components: {
    BkTable,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    skuCode: {
      type: String,
      default: '',
    },
    productId: {
      type: String,
      default: '',
    },
  },
  computed: {
    isShow: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
  data() {
    return {
      filter: {
        keyword: '',
        state: null,
        invalidFeedbackSMG: '',
      },
      items: [],
      fields: [
        {
          key: 'index',
          formatter: (value, key, item) => {
            return FormatQty(value ? value : 0)
          },
          label: 'ลำดับ',
          thStyle: 'width:80px',
          tdClass: 'text-center',
          sortable: true,
        },
        {
          key: 'postcode',
          label: 'Postcode Restriction',
          tdClass: 'text-left',
          sortable: true,
        },
        {
          key: 'province',
          label: 'Province',
          tdClass: 'text-left',
          sortable: true,
        },
        {
          key: 'action',
          label: 'Action',
          thStyle: 'width:80px',
        },
      ],
    }
  },
  methods: {
    async onSaveAddPostCode() {
      const items = this.items
      const sku_code = this.skuCode
      if (!items || items.length === 0) {
        this.$utils.notification('error', 'ไม่มีข้อมูลที่บันทึกได้', 2000)
        return
      }

      if (!sku_code) {
        this.$utils.notification(
          'error',
          'ไม่มีข้อมูลที่บันทึกได้ <br/> (SkuCode ไม่ถูกต้อง)',
          2000
        )
        return
      }

      const data = items.map(it => ({
        sku_code,
        postcode: it.postcode,
      }))
      const result = await productDeliveryRestrictionService.createPostCodeAsync(
        data
      )

      if (result.status === 201 || result.status === 200) {
        this.$utils.notification('success', 'บันทึกข้อมูลสำเร็จ', 2000)
        this.$emit('reload')
        this.filter = {
          keyword: '',
          state: null,
          invalidFeedbackSMG: '',
        }
        this.items = []
        this.isShow = false
      } else if (
        (result.status && result.status === 404) ||
        (result.response.status && result.response.status === 404)
      ) {
        console.log('error', result.response.data.message)
      } else if (
        (result.status && result.status !== 500) ||
        (result.response && result.response.status !== 500)
      ) {
        this.$utils.notification('error', result.response.data.message, 2000)
      }
    },
    async onResetAddPostCode() {
      const confirm = await this.$utils.confirmAlertDisplay(
        'ต้องการ Reset Postcode ทั้งหมดหรือไม่?',
        `กด Yes เพื่อยืนยัน!`
      )
      if (!confirm) {
        return
      }
      this.filter = {
        keyword: '',
        state: null,
        invalidFeedbackSMG: '',
      }
      this.items = []
    },
    onDeletePostcode(data) {
      const postcode = data.item.postcode
      this.items = this.items.filter(it => it.postcode !== postcode)
    },
    async onFilter() {
      this.filter.state = null
      this.filter.invalidFeedbackSMG = ''

      const sku_code = this.skuCode
      const postcode = this.filter.keyword
      const data = { sku_code, postcode }

      if (!postcode) {
        this.filter.state = false
        this.filter.invalidFeedbackSMG = 'กรุณากรอกรหัสไปรษณีย์'
        return
      }
      if (this.items.find(it => it.postcode === postcode)) {
        this.filter.state = false
        this.filter.invalidFeedbackSMG = 'กรอกรหัสไปรษณีย์แล้ว'
        return
      }
      const res = await this.checkPostcodeValidAsync([data])
      const result = res[0]
      if (!result) {
        this.filter.state = false
        this.filter.invalidFeedbackSMG = 'กรอกรหัสไปรษณีย์ไม่ถูกต้อง'
        return
      }
      const isPostcodesValid = result.isPostcodesValid
      if (!isPostcodesValid) {
        this.filter.state = false
        this.filter.invalidFeedbackSMG = 'กรอกรหัสไปรษณีย์ไม่ถูกต้อง'
        return
      }
      const isExistPostcode = result.isExistPostcode
      if (isExistPostcode) {
        this.filter.state = false
        this.filter.invalidFeedbackSMG = 'มีรหัสไปรษณีย์อยู่ในระบบแล้ว'
        return
      }
      this.items.push(result)
      this.filter.keyword = null
      this.filter.state = null
      this.filter.invalidFeedbackSMG = ''
    },
    async checkPostcodeValidAsync(data) {
      const result = await productDeliveryRestrictionService.checkPostcodeValidAsync(
        data
      )
      if (result.status === 200) {
        return result.data
      } else if (
        (result.status && result.status === 404) ||
        (result.response.status && result.response.status === 404)
      ) {
        console.log('error', result.response.data.message)
        return false
      } else if (
        (result.status && result.status !== 500) ||
        (result.response && result.response.status !== 500)
      ) {
        this.$utils.notification('error', result.response.data.message, 2000)
        return false
      }
    },
    async validatePostCode(e) {
      const textLength = this.filter.keyword.length || 0
      if (textLength !== 5) {
        return
      }
      this.filter.state = null
      this.filter.invalidFeedbackSMG = ''

      const sku_code = this.skuCode
      const postcode = this.filter.keyword
      const data = { sku_code, postcode }

      if (!postcode) {
        this.filter.state = false
        this.filter.invalidFeedbackSMG = 'กรุณากรอกรหัสไปรษณีย์'
        return
      }
      if (this.items.find(it => it.postcode === postcode)) {
        this.filter.state = false
        this.filter.invalidFeedbackSMG = 'กรอกรหัสไปรษณีย์แล้ว'
        return
      }
      const res = await this.checkPostcodeValidAsync([data])
      const result = res[0]
      if (!result) {
        this.filter.state = false
        this.filter.invalidFeedbackSMG = 'กรอกรหัสไปรษณีย์ไม่ถูกต้อง'
        return
      }
      const isPostcodesValid = result.isPostcodesValid
      if (!isPostcodesValid) {
        this.filter.state = false
        this.filter.invalidFeedbackSMG = 'กรอกรหัสไปรษณีย์ไม่ถูกต้อง'
        return
      }
      const isExistPostcode = result.isExistPostcode
      if (isExistPostcode) {
        this.filter.state = false
        this.filter.invalidFeedbackSMG = 'มีรหัสไปรษณีย์อยู่ในระบบแล้ว'
        return
      }
      this.filter.state = true
      this.filter.invalidFeedbackSMG = ''
    },
  },
}
</script>

<style scoped></style>
